<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12">
        <v-toolbar-title>Home</v-toolbar-title>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="6" md="6">
        <card-widget
          icon="mdi-wallet"
          label="Current Load Balance"
          :value="loadingData ? 0 : loadBalance"
          type="string"
        ></card-widget>
      </v-col>

      <v-col cols="12" lg="6" md="6">
        <card-widget
          icon="mdi-wallet-outline"
          label="Current Install Balance"
          type="string"
          :value="loadingData ? 0 : installBalance"
        ></card-widget>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ShareableMethods from "@/mixins/ShareableMethods";
import CardWidget from "../../components/CardWidget.vue";
export default {
  mixins: [ShareableMethods],
  name: "HomeDistributor",
  components: { CardWidget },

  data() {
    return {
      loadingData: true,
      installBalance: 0,
      loadBalance: 0,
    };
  },

  methods: {
    async getList() {
      const { adminLogin } = this.userData;
      await this.$drs
        .post(`/broker/drs/distributor-info`, {
          distributorId: adminLogin.distributorId,
        })
        .then((response) => {
          this.loadingData = false;
          const newArr = response.data.data;
          this.installBalance = newArr[0].installWallet;
          this.loadBalance = newArr[0].loadWallet;
        })
        .catch((e) => {
          this.loadingData = false;
          console.log(e);
        });
    },
  },

  created() {
    this.getList();
  },

  computed: {
    userData() {
      return this.$store.getters.userData;
    },
  },
};
</script>
